import { transportationProviderDetailsComponent } from './transportation-provider-details.component';
import './transportation-provider-details.scss';

export const transportationProviderDetails = angular
     .module('components.transportationProviderDetails', [])
     .component('transportationProviderDetails', transportationProviderDetailsComponent)
    //  .config(($stateProvider) => {
    //  	'ngInject';

    //  	$stateProvider
	// 	.state('transportationProviderDetails', {
	// 		url: '/transportation-information/transportation-providers/:id/detail',
	// 		component: 'transportationProviderDetails',
	// 		breadcrumbName: 'Provider Details',
	// 		parentState: 'TransportationProviders',
    //            resolve: {
    //                 details(TransportationProvidersService, $stateParams) {
    //                      'ngInject';

    //                      return TransportationProvidersService.getProviderDetailsById($stateParams.id)
    //                 }
    //            }
	// 	});
    //  })
     .name;


// WEBPACK FOOTER //
// ./src/app/components/transportation-provider-details/transportation-provider-details.module.js